import React from 'react';

import DashIcon from '../../../../../assets/svgComponents/LeftNavigationIcons/DashIcon';
import TickIcon from '../../../../../assets/svgComponents/LeftNavigationIcons/TickIcon';

import './checkBoxComponentV2.css';

const CheckBoxComponentV2 = ({
  isDisabled = false,
  isChecked = false,
  showMinusIcon = false,
  onClick = () => {},
}) => {
  return (
    <div
      className={`et-v2-check-box-container ${
        isChecked ? 'et-v2-check-box-container-checked' : ''
      } ${isDisabled ? 'et-v2-check-box-container-disabled' : ''}`}
      onClick={(e) => {
        //to prevent handleOutsideEvent from being triggered due to click on svg/path
        e.stopPropagation();
        onClick();
      }}>
      {isChecked && showMinusIcon && <DashIcon />}
      {isChecked && !showMinusIcon && <TickIcon />}
    </div>
  );
};

export default CheckBoxComponentV2;
